'use strict';
(function () {
  angular.module('pentaApp').factory('preTurnValidation.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/preTurnValidation', {}, {
      validate: {
        method: 'POST'
      }
    });
  }
})();
